webpackJsonp([37085905274928],{

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var acupunctureTreats = function acupunctureTreats() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h2',
	      null,
	      'What does Acupuncture Treat?'
	    ),
	    _react2.default.createElement(
	      'span',
	      null,
	      _react2.default.createElement(
	        'i',
	        null,
	        'The National Institute of Health (NIH) and World Health Organization (WHO) recognize acupuncture as effective for treating the following conditions:'
	      )
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Ear, Eye, Nose, Throat Disorders:'
	        ),
	        ' Sinusitis \u2022 Sore throat \u2022 Hay fever \u2022 Earache \u2022 Nerve deafness \u2022 Ringing in the ears \u2022 Dizziness \u2022 Poor eyesight'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Circulatory Disorders:'
	        ),
	        ' High blood pressure \u2022 Angina pectoris \u2022 Arteriosclerosis \u2022 Anemia'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Gastrointestinal Disorders:'
	        ),
	        ' Irritable bowel syndrome \u2022 Spastic colon \u2022 Colitis \u2022 Constipation \u2022 Diarrhea \u2022 Food Allergies \u2022 Ulcers \u2022 Gastritis \u2022 Abdominal bloating \u2022 Hemorrhoids'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Gynecological and Genitourinary Disorders:'
	        ),
	        ' Premenstrual syndrome (PMS) \u2022 Irregular, heavy, or painful menstruation \u2022 Endometriosis \u2022 Menopause \u2022 Fibroids \u2022 Chronic bladder infection \u2022 Complications in pregnancy \u2022 Morning sickness \u2022 Kidney stones \u2022 Impotence \u2022 Infertility in men and women \u2022 Sexual dysfunction'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Immune Disorders:'
	        ),
	        ' Candida \u2022 Chronic fatigue \u2022 HIV and AIDS \u2022 Epstein Barr virus \u2022 Allergies \u2022 Lupus \u2022 MS \u2022 Hepatitis'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Addiction:'
	        ),
	        ' Smoking Cessation \u2022 Drugs \u2022 Alcohol'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Emotional and Psychological Disorders:'
	        ),
	        ' Anxiety \u2022 Insomnia \u2022 Depression \u2022 Stress'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Musculoskeletal and Neurological Disorders:'
	        ),
	        ' Arthritis \u2022 Neuralgia \u2022 Sciatica \u2022 Back pain \u2022 Bursitis \u2022 Tendonitis \u2022 Stiff neck \u2022 Bell\u2019s palsy \u2022 Trigeminal Neuralgia \u2022 Headaches and Migraines \u2022 Stroke \u2022 Cerebral palsy \u2022 Polio \u2022 Sprains \u2022 Muscle spasms \u2022 Shingles'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Respiratory Disorders:'
	        ),
	        ' Asthma \u2022 Emphysema \u2022 Bronchitis \u2022 Colds and flu'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Miscellaneous:'
	        ),
	        ' Chemotherapy and radiation side effects \u2022 Diabetes \u2022 Dermatological disorders \u2022 Weight control'
	      )
	    ),
	    _react2.default.createElement('br', null)
	  );
	};
	
	exports.default = acupunctureTreats;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-acupuncture-treats-js-e1c9a6401b50dab290ea.js